module.exports = __webpack_public_path__ + "img/overview.dd62e2b2.svg";